import { render, staticRenderFns } from "./AutoAllocateButton.vue?vue&type=template&id=5a90df33"
import script from "./AutoAllocateButton.vue?vue&type=script&lang=js"
export * from "./AutoAllocateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports